import axios from "axios";
// initial state
const state = {};

// getters
const getters = {};

// actions
const actions = {
  GetAllTemplates({ commit }, list) {
    return new Promise(resolve => {
      axios({
        url: "/sms_template/list?order_by=created_on&order_dir=desc",
        params: {
          page: list.page,
          per_page: list.per_page ? list.per_page : 10,
          template_name: list.template_name ? '*' + list.template_name + '*' : '',
          status: list.status !== 'all' ? list.status : null,
          created_on_gt: list.created_on_gt ? list.created_on_gt : '',
          order_by: list.order_by,
          order_dir: list.order_dir,
        },
        method: "GET"
      }).then(res => {
        resolve(res.data.payload);
      });
    });
  },
  GetNewTemplates({ commit }, list) {
    return new Promise(resolve => {
      axios({
        url: "/sms_template/list?order_by=created_on&order_dir=desc",
        params: {
          status: list.status ? list.status : '',
          page: list.page,
          template_name: list.template_name ? '*' + list.template_name + '*' : '',
          created_on_gt: list.created_on_gt ? list.created_on_gt : ''
        },
        method: "GET"
      }).then(res => {
        resolve(res.data.payload);
      });
    });
  },
  AddTemplate({ commit }, template) {

    return new Promise((resolve, reject) => {
      axios({
        url: "/sms_template",
        data: template.template,
        method: "POST"
      }).then(res => {
        resolve(res.data.payload);
      }).catch(err => {
        console.log("err.response.data", err.response.data)
        reject(err);
      });
    });
  },
  EditTemplate({ commit }, data) {

    return new Promise((resolve, reject) => {
      axios({
        url: "/sms_template/" + data.template.id,
        data: data.template,
        method: "PATCH"
      }).then(res => {
        resolve(res.data.payload);
      }).catch(err => {
        console.log("err.response.data", err.response.data)
        reject(err);
      });
    });
  },
  GetTemplate({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/sms_template/" + id,
        method: "GET"
      }).then(res => {
        resolve(res.data.payload);
      }).catch(err => {
        console.log("err.response.data", err.response.data)
        reject(err);
      });
    });
  },
  DeleteTemplate({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/sms_template/" + id,
        method: "DELETE"
      }).then(res => {
        resolve(res.data.payload);
      }).catch(err => {
        console.log("err.response.data", err.response.data)
        reject(err);
      });
    });
  },
  ApproveTemplate({ commit }, template) {
    console.log("from post", template)
    return new Promise((resolve, reject) => {
      axios({
        url: "/sms_template/" + template.id + "/approve",
        // data: template.template,
        method: "PATCH"
      }).then(res => {
        resolve(res.data.payload);
      }).catch(err => {
        console.log("err.response.data", err.response.data)
        reject(err);
      });;
    });
  },
  RejectTemplate({ commit }, template) {
    console.log("from post", template)
    return new Promise((resolve, reject) => {
      axios({
        url: "/sms_template/" + template.id + "/reject",
        // data: template.template,
        method: "PATCH"
      }).then(res => {
        resolve(res.data.payload);
      }).catch(err => {
        console.log("err.response.data", err.response.data)
        reject(err);
      });;
    });
  },
};

// mutations
const mutations = {

};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
